<template>
  <div class="balance-log-container">
    <!-- 查询条件 -->
    <div class="search-form">
      <el-form :model="queryParams" inline size="small">
        <el-form-item label="手机号">
          <el-input v-model="queryParams.phone" placeholder="请输入手机号" clearable style="width: 160px" />
        </el-form-item>
        <el-form-item label="交易流水号">
          <el-input v-model="queryParams.consumptionNo" placeholder="consumption_no" clearable style="width: 220px" />
        </el-form-item>
        <el-form-item label="交易单号">
          <el-input v-model="queryParams.tradeNo" placeholder="trade_no" clearable style="width: 200px" />
        </el-form-item>
        <br/>
        <el-form-item label="业务类型">
          <el-select v-model="queryParams.bizType" placeholder="全部" clearable style="width: 180px">
            <el-option label="全部" value="" />
            <el-option
              v-for="(label, val) in bizTypeMap"
              :key="val"
              :label="label"
              :value="label"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="流水类型">
          <el-select v-model="queryParams.type" placeholder="全部" clearable style="width: 120px">
            <el-option label="全部" value="" />
            <el-option label="充值" value="RECHARGE" />
            <el-option label="消费" value="CONSUME" />
            <el-option label="退款" value="REFUND" />
          </el-select>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="queryParams.cardNo" placeholder="储值卡号" clearable style="width: 180px" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="queryParams.remark" placeholder="备注模糊查询" clearable style="width: 200px" />
        </el-form-item>
        <br/>
        <el-form-item label="交易时间">
          <el-date-picker
            v-model="queryParams.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 340px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button v-permission="'balancelog:export'" type="warning" icon="el-icon-download" :loading="exportLoading" :disabled="exportStatus === 'RUNNING'" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 导出进度 -->
    <div v-if="exportTaskId" class="export-progress-section">
      <h3>导出进度</h3>
      <div v-if="exportStatus === 'RUNNING'" class="loading-progress">
        <div class="progress-bar-cycling"></div>
        <div class="progress-message">
          {{ exportTask.message || '正在生成文件...' }}
          <span v-if="exportTask.total > 0">（{{ exportTask.processed }}/{{ exportTask.total }}）</span>
        </div>
      </div>
      <div v-else-if="exportStatus === 'DONE'" class="progress-result">
        <el-progress :percentage="100" status="success" :stroke-width="20"></el-progress>
        <div class="progress-info">
          <span>总计: <strong>{{ exportTask.total }}</strong></span>
          <span class="text-success">已完成</span>
        </div>
        <div v-if="exportTask.message" class="progress-message">{{ exportTask.message }}</div>
        <div class="action-buttons">
          <el-button icon="el-icon-close" @click="clearExportTask">关闭</el-button>
        </div>
      </div>
      <div v-else-if="exportStatus === 'ERROR'" class="progress-error">
        <el-alert :title="exportTask.message || '导出失败'" type="error" :closable="false" show-icon></el-alert>
        <div class="action-buttons">
          <el-button icon="el-icon-close" @click="clearExportTask">关闭</el-button>
        </div>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="content-wrapper">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="consumptionNo" label="流水号(consumption_no)" min-width="240" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="tradeNo" label="交易单号(trade_no)" min-width="260" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="cardNo" label="储值卡号" min-width="150" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="phone" label="手机号" min-width="120" align="center" fixed="left">
          <template slot-scope="{ row }">
            <span v-if="row.memberId" style="cursor: pointer" @click="handleViewMember(row.phone)">{{ row.phone }}</span>
            <template v-else-if="row.phone">{{ row.phone }}<el-tag size="mini" type="info" style="margin-left: 4px">非会员</el-tag></template>
            <el-tag v-else size="mini" type="info">非会员</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" min-width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="bizType" label="业务类型" width="130" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info">{{ row.bizType || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="流水类型" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="typeTagMap[row.type] || 'info'" size="small">{{ typeNameMap[row.type] || row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="变动金额(元)" width="110" align="center">
          <template slot-scope="{ row }">
            <span :style="{ color: row.amount >= 0 ? '#67C23A' : '#F56C6C', fontWeight: 'bold' }">
              {{ row.amount >= 0 ? '+' : '' }}{{ formatAmount(row.amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="principalConsumptionAmount" label="本金变动(元)" width="105" align="center">
          <template slot-scope="{ row }">
            <span :style="{ color: shouldShowPositive(row.type, 'principal') ? '#67C23A' : '#F56C6C', fontWeight: 'bold' }">
              {{ shouldShowPositive(row.type, 'principal') ? '+' : '' }}{{ formatAmount(getSignedAmount(row, 'principal')) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="bonusConsumptionAmount" label="赠送金变动(元)" width="115" align="center">
          <template slot-scope="{ row }">
            <span :style="{ color: shouldShowPositive(row.type, 'bonus') ? '#67C23A' : '#F56C6C', fontWeight: 'bold' }">
              {{ shouldShowPositive(row.type, 'bonus') ? '+' : '' }}{{ formatAmount(getSignedAmount(row, 'bonus')) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sumDnom" label="卡余额(元)" width="95" align="center">
          <template slot-scope="{ row }">
            <span class="font-bold">{{ formatAmount(row.sumDnom) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="principalDnom" label="本金余额(元)" width="95" align="center">
          <template slot-scope="{ row }">
            <span>{{ formatAmount(row.principalDnom) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bonusDnom" label="赠送金余额(元)" width="105" align="center">
          <template slot-scope="{ row }">
            <span>{{ formatAmount(row.bonusDnom) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="valid" label="有效" width="65" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.valid === '有效' ? 'success' : 'danger'" size="small">
              {{ row.valid || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="acceptShopName" label="受理店铺" min-width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="channel" label="渠道" width="70" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.channel === 'ONLINE' ? '' : 'warning'" size="small" effect="plain">
              {{ row.channel === 'ONLINE' ? '线上' : (row.channel === 'OFFLINE' ? '线下' : row.channel) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="tradeTime" label="交易时间" min-width="165" align="center">
          <template slot-scope="{ row }">
            {{ formatTime(row.tradeTime) || formatTime(row.createTime) || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="tradeRemark" label="备注" min-width="320" align="center" show-overflow-tooltip />
      </el-table>

      <!-- 分页 -->
      <Pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { getBalanceLogList } from '@/api/balanceLog'
import { submitExport, getExportTask, downloadExport } from '@/api/export'
import request from '@/utils/request'
import Pagination from '@/components/Pagination/index.vue'

export default {
  name: 'BalanceLog',
  components: { Pagination },
  data() {
    return {
      queryParams: {
        phone: '',
        consumptionNo: '',
        tradeNo: '',
        cardNo: '',
        remark: '',
        bizType: '',
        orderNo: '',
        type: '',
        timeRange: [],
        pageNum: 1,
        pageSize: 10
      },
      tableLoading: false,
      exportLoading: false,
      tableData: [],
      total: 0,
      typeNameMap: { RECHARGE: '充值', CONSUME: '消费', REFUND: '退款' },
      typeTagMap: { RECHARGE: 'success', CONSUME: 'danger', REFUND: 'warning' },
      bizTypeMap: {
        // 实际数据中最常见的类型放前面
        '支付': '支付',
        '礼品卡激活': '礼品卡激活',
        // 其他类型（英文枚举，兼容数据）
        'RECHARGE': '充值',
        'GROUP_GIVE_RECHARGE': '赠送',
        'REFUND': '退款',
        'RECHARGE_REFUND': '充值退款',
        'PAY': '消费',
        'CARD_ACCOUNT_ADJUSTMENT_ADD': '调账增加',
        'CARD_ACCOUNT_ADJUSTMENT_SUBTRACT': '调账减少',
        'CARD_BALANCE_IMPORT_ADD': '导入增加',
        'CARD_BALANCE_IMPORT_SUBTRACT': '导入减少',
        'RECEDE_CARD': '退卡',
        'GIFT_CARD_ACTIVE': '激活',
        'RECHARGE_BONUS': '充值赠送',
        'REFUND_CLOSE_TRANSFER_IN': '退款销卡转入',
        'REFUND_CLOSE_TRANSFER_OUT': '退款销卡转出',
        'COMBINE_IN': '卡换绑转入',
        'COMBINE_OUT': '卡换绑转出'
      },
      // 异步导出状态
      exportTaskId: null,
      exportStatus: '',
      exportTask: {},
      exportPollingTimer: null
    }
  },
  created() {
    this.getList()
    this.recoverExportProgress()
  },
  beforeDestroy() {
    this.stopExportPolling()
  },
  methods: {
    getList() {
      this.tableLoading = true
      const params = { ...this.queryParams }
      if (params.timeRange && params.timeRange.length === 2) {
        params.startTime = params.timeRange[0]
        params.endTime = params.timeRange[1]
      }
      delete params.timeRange

      getBalanceLogList(params).then(res => {
        this.tableData = res.data.records || res.data.list || []
        this.total = res.data.total || 0
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.tableLoading = false
      })
    },

    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-'
      return Number(val).toFixed(2)
    },

    // 根据流水类型判断本金/赠送金是否显示为正数
    // RECHARGE(充值)、REFUND(退款) → 正数；CONSUME(消费) → 负数
    shouldShowPositive(type, field) {
      if (type === 'CONSUME') return false
      return true
    },

    // 根据流水类型返回带符号的金额值
    getSignedAmount(row, field) {
      const val = field === 'principal' ? row.principalConsumptionAmount : row.bonusConsumptionAmount
      if (val === null || val === undefined || val === '' || val === 0) return 0
      if (row.type === 'CONSUME') return -Math.abs(Number(val))
      return Math.abs(Number(val))
    },

    formatTime(time) {
      if (!time) return ''
      return String(time).replace('T', ' ')
    },

    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },

    // 查看会员详情
    handleViewMember(phone) {
      this.$router.push({ path: '/member', query: { phone } })
    },

    handleReset() {
      this.queryParams = {
        phone: '',
        consumptionNo: '',
        tradeNo: '',
        cardNo: '',
        remark: '',
        bizType: '',
        orderNo: '',
        type: '',
        timeRange: [],
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },

    handleExport() {
      const params = { ...this.queryParams, pageNum: undefined, pageSize: undefined }
      if (params.timeRange && params.timeRange.length === 2) {
        params.startTime = params.timeRange[0]
        params.endTime = params.timeRange[1]
      }
      delete params.timeRange

      this.exportLoading = true
      submitExport('balanceLog', params).then(res => {
        this.exportTaskId = res.data.taskId
        this.exportStatus = 'RUNNING'
        this.exportTask = { message: res.data.message || '正在生成文件...' }
        this.startExportPolling()
      }).catch(err => {
        this.$message.error(err.message || '导出提交失败')
      }).finally(() => {
        this.exportLoading = false
      })
    },

    recoverExportProgress() {
      const cached = sessionStorage.getItem('balanceLogExportTask')
      if (!cached) return
      try {
        const { taskId } = JSON.parse(cached)
        getExportTask(taskId).then(res => {
          const task = res.data
          if (task.status === 'RUNNING') {
            this.exportTaskId = taskId
            this.exportStatus = 'RUNNING'
            this.exportTask = task
            this.startExportPolling()
          } else if (task.status === 'DONE' || task.status === 'ERROR') {
            this.exportTaskId = taskId
            this.exportStatus = task.status
            this.exportTask = task
          } else {
            sessionStorage.removeItem('balanceLogExportTask')
          }
        }).catch(() => {
          sessionStorage.removeItem('balanceLogExportTask')
        })
      } catch (e) {
        sessionStorage.removeItem('balanceLogExportTask')
      }
    },

    startExportPolling() {
      this.stopExportPolling()
      sessionStorage.setItem('balanceLogExportTask', JSON.stringify({ taskId: this.exportTaskId }))
      this.pollExportTask()
      this.exportPollingTimer = setInterval(() => {
        this.pollExportTask()
      }, 3000)
    },

    pollExportTask() {
      getExportTask(this.exportTaskId).then(res => {
        const task = res.data
        this.exportTask = task
        this.exportStatus = task.status
        if (task.status === 'DONE' || task.status === 'ERROR') {
          this.stopExportPolling()
          if (task.status === 'DONE') {
            this.autoDownloadExport()
          }
        }
      }).catch(() => {
        this.exportStatus = 'ERROR'
        this.exportTask = { message: '查询进度失败' }
        this.stopExportPolling()
      })
    },

    stopExportPolling() {
      if (this.exportPollingTimer) {
        clearInterval(this.exportPollingTimer)
        this.exportPollingTimer = null
      }
    },

    autoDownloadExport() {
      if (!this.exportTaskId) return
      downloadExport(this.exportTaskId).then(() => {
        this.$message.success('导出完成，文件已下载')
      }).catch(() => {
        this.$message.error('下载失败')
      })
    },

    clearExportTask() {
      this.exportTaskId = null
      this.exportStatus = ''
      this.exportTask = {}
      this.stopExportPolling()
      sessionStorage.removeItem('balanceLogExportTask')
    }
  }
}
</script>

<style lang="less" scoped>
.balance-log-container {
  height: 100%;
}
.font-bold {
  font-weight: bold;
}

/* 导出进度 */
.export-progress-section {
  margin: 16px 20px;
  padding: 16px 20px;
  background: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #EBEEF5;
  h3 {
    font-size: 16px;
    margin: 0 0 16px;
  }
  .loading-progress {
    .progress-bar-cycling {
      height: 20px;
      border-radius: 10px;
      background: #EBEEF5;
      position: relative;
      overflow: hidden;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 30%;
        height: 100%;
        background: #409EFF;
        border-radius: 10px;
        animation: export-cycling 2s ease-in-out infinite;
      }
    }
    .progress-message {
      margin-top: 8px;
      color: #606266;
      font-size: 13px;
      text-align: center;
    }
  }
  .progress-result {
    .progress-info {
      display: flex;
      gap: 16px;
      margin-top: 12px;
      font-size: 14px;
    }
    .progress-message {
      margin-top: 8px;
      color: #606266;
      font-size: 13px;
    }
    .action-buttons {
      margin-top: 16px;
    }
  }
  .progress-error {
    .action-buttons {
      margin-top: 12px;
    }
  }
}

@keyframes export-cycling {
  0% { left: -30%; }
  50% { left: 100%; }
  100% { left: -30%; }
}

.text-success { color: #67C23A; }
</style>
